<template>
  <div>
    <PivotTableModal
      :cur-widget="dataKey"
      :cur-headers="headers"
      :cur-data-providers="dataProviders"
      />
    <b-button variant="primary" @click="editTable">Edit</b-button>
    <div :id="'pivottable_' + dataKey"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import PivotTableModal from '@/components/Modals/PivotTable'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'
import { setInterval } from 'timers';

let $ = window.$

export default {
  props: [ 'dataKey' ],
  components: {
    PivotTableModal
  },
  data () {
    return {
      headers: [],
      dataProviders: [],
      data: []
    }
  },
  computed: {
    ...mapState([
      '$sheets'
    ])
  },
  methods: {
    editTable () {
      eventBus.$emit('showEditPivotTableModal')
    }
  },
  // freaking hack
  created () {
    setInterval(function () {
      $("th:contains('function (index) {')").remove()
      // $(".pvtRenderer option:contains('Table Barchart')").remove()
      $(".pvtRenderer option[value='Heatmap']").remove()
      $(".pvtRenderer option[value='Table Barchart']").remove()
    }, 100)
  },
  mounted () {
    db.getRef('widgetsData/pivottables/' + this.dataKey).on('value', (snapshot) => {
      let data = snapshot.val()
      this.headers = []
      this.data = []

      if (!data) return

      for (let sheet of data.dataProviders) {
        this.data.push(...this.$sheets[sheet].getData(Array))
      }

      this.headers = data.headers
      this.dataProviders = data.dataProviders
      if (data.options) {
        let options = JSON.parse(data.options)

        let result = {
          aggregatorName: options.aggregatorName,
          rendererName: options.rendererName,
          colOrder: options.colOrder,
          rowOrder: options.rowOrder,
          cols: options.cols,
          rows: options.rows,
          vals: options.vals,
          exclusions: options.exclusions,
          sorters: options.sorters,
          onRefresh (config) {
            db.pivotTable.updateOptions(config, vm.dataKey)
          }
        }

        this.options = result
      } else {
        this.options = {
          onRefresh (config) {
            db.pivotTable.updateOptions(config, vm.dataKey)
          }
        }
      }
    })

    let vm = this
    let tableData
    if (vm.headers) {
      tableData = [
        vm.headers,
        ...vm.data
      ]
    } else {
      tableData = [
        ...vm.data
      ]
    }
    $('#pivottable_' + this.dataKey).pivotUI(
      tableData,
      vm.options
    )
  },
  beforeDestroy () {
    this.headers = null
    this.data = null
    this.dataProviders = null
    this.eventBus = null
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PivotTable/index.vue